import { fromHtml2Mdast } from 'src/utils/ast-util';

import type { PasteHook } from '../types';
import { mdast2Block } from './helper/mdast-block';

export const pasteHTML = (props: PasteHook, html: string) => {
  const mdast = fromHtml2Mdast(html);

  if (!mdast) return;

  mdast2Block(props, mdast);
};
